import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UploadLyricsPopup from '../order/UploadLyricsPopup';
import UploadAudioPopup from '../order/UploadAudioPopup';

const sampleOrders = [
  {
    id: 201,
    companyName: 'Alpha Media',
    brief: 'Bold jingle for rebrand campaign',
    salesPerson: 'Riya Kumar',
    createdAt: '2025-10-09',
    status: 'Pending',
  },
  {
    id: 202,
    companyName: 'Sunrise Foods',
    brief: 'Fresh tune for breakfast range',
    salesPerson: 'Liam Patel',
    createdAt: '2025-10-10',
    status: 'Processing',
  },
  {
    id: 203,
    companyName: 'City Bank',
    brief: 'Trust-building musical motif',
    salesPerson: 'Ava Chen',
    createdAt: '2025-10-12',
    status: 'Pending',
  },
];

function MusicCreatorMyOrders({ filteredOrders }) {
  const navigate = useNavigate();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrderForUpload, setSelectedOrderForUpload] = useState(null);
  const [showUploadLyrics, setShowUploadLyrics] = useState(false);
  const [showUploadAudio, setShowUploadAudio] = useState(false);


  const goToDetails = (orderId) => {
    navigate(`/music-creator/my-orders/${orderId}`);
  };

  const updateOrderStatus = (orderId, newStatus, additionalData = {}) => {
    const updatedOrders = filteredOrders.map((order) =>
      order.id === orderId
        ? {
          ...order,
          status: newStatus,
          ...additionalData,
          updatedAt: new Date().toISOString(),
        }
        : order
    );
    // saveOrders(updatedOrders);
  };

  const handleUploadLyrics = (order) => {
    setSelectedOrderForUpload(order);
    setShowUploadLyrics(true);
  };

  const handleUploadAudio = (order) => {
    setSelectedOrderForUpload(order);
    setShowUploadAudio(true);
  };


  return (
    // <div className="min-h-screen ">
    // <div className="max-w-6xl mx-auto px-6 py-8">
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Sr No
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Company
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Contact
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Sales Person
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredOrders.map((order, index) => (
              <tr key={order.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm text-gray-700">
                  {index + 1}
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm font-medium text-gray-900">
                    {order.companyName || "-"}
                  </div>
                  <div className="text-xs text-gray-500">
                    {order.brief || order.layerStatement || "-"}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-900">
                    {order.contactPerson || "-"}
                  </div>
                  <div className="text-xs text-gray-500">
                    {order.emailAddress || order.mobileNumber || "-"}
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-gray-700">
                  {order.createdAt
                    ? new Date(order.createdAt).toLocaleDateString()
                    : "-"}
                </td>
                <td className="px-6 py-4">
                  <select
                    value={order.status || "pending"}
                    onChange={(e) =>
                      updateOrderStatus(order.id, e.target.value)
                    }
                    className="px-3 py-2 border-2 border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                  >
                    <option value="pending">Pending</option>
                    {/* <option value="in-progress">In Progress</option> */}
                    <option value="completed">Completed</option>
                    <option value="delivered">Delivered</option>
                    <option value="lyric-approved">Lyric Approved</option>
                    <option value="lyric-approval-pending">
                      Lyric Approval Pending
                    </option>
                    <option value="recreation-lyrics">
                      Recreation on Lyrics
                    </option>
                    <option value="recreation-song">
                      Recreation on Song
                    </option>
                  </select>
                </td>
                <td className="px-6 py-4 space-x-2 flex">
                  <button
                    onClick={() => setSelectedOrder(order)}
                    className="inline-flex items-center px-3 py-1.5 text-sm bg-orange-600 text-white rounded-lg hover:bg-orange-700"
                  >
                    View Details
                  </button>

                  <button
                    onClick={() => handleUploadLyrics(order)}
                    className="inline-flex items-center px-3 py-1.5 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700"
                  >
                    Upload Lyrics
                  </button>
                  <button
                    onClick={() => handleUploadAudio(order)}
                    className="inline-flex items-center px-3 py-1.5 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700"
                  >
                    Upload Audio
                  </button>
                  {/* <button
                          onClick={() => deleteOrder(order.id)}
                          className="inline-flex items-center px-3 py-1.5 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700"
                        >
                          Delete
                        </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showUploadLyrics && (
        <UploadLyricsPopup
          order={selectedOrderForUpload}
          onClose={() => {
            setShowUploadLyrics(false);
            setSelectedOrderForUpload(null);
          }}
        // onUpload={handleLyricsUploadComplete}
        />
      )}

      {showUploadAudio && (
        <UploadAudioPopup
          order={selectedOrderForUpload}
          onClose={() => {
            setShowUploadAudio(false);
            setSelectedOrderForUpload(null);
          }}
        // onUpload={handleAudioUploadComplete}
        />
      )}
    </div>
  );
}

export default MusicCreatorMyOrders;